import { FC, HTMLAttributes } from "react";
import { useStyles } from "./GameFeed.style";
import { useState } from "react";
import GamingLoading from "../GamingLoading/GamingLoading";
import { NotchItem } from "../NotchItem/NotchItem";
import { NotchMenu } from "../NotchMenu/NotchMenu";

interface IActiveIframeProps {
  iframeUrl: string;
  feedId: string;
  onCloseIframe: () => void;
  title?: string;
}

export const ActiveIframe: FC<
  IActiveIframeProps & HTMLAttributes<HTMLDivElement>
> = ({ iframeUrl, feedId, title, onCloseIframe }) => {
  const classes = useStyles();
  const [isLoadingIframe, setLoadingIframe] = useState(false);
  const [openNotchMenu, setOpenNotchMenu] = useState(false);

  const onClose = async () => {
    setOpenNotchMenu(false);
  };

  return (
    <>
      <NotchItem onClose={() => setOpenNotchMenu(true)} open={!openNotchMenu} />
      <NotchMenu
        onClose={onClose}
        open={openNotchMenu}
        onAction={onCloseIframe}
        feedId={feedId}
      />
      {isLoadingIframe && <GamingLoading />}
      <iframe
        onLoad={() => setLoadingIframe(false)}
        id="documentation"
        title={title}
        className={classes.iframe}
        src={iframeUrl}
      />
    </>
  );
};
